import styled from 'styled-components';

import SolarIcon from '../../assets/svg/icon/solar.svg';

const IconWrapper = styled.div<{ top: number }>`
  position: absolute;
  top: ${({ top }) => top}px;
  width: 100%;
  z-index: 100;
`;
const IconDisc = styled.div`
  background: ${(props) => props.theme.colors.gradients.solarReverse};
  border-radius: 50%;
  border: 3px solid ${(props) => props.theme.colors.white};
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
  width: 85px;
`;

interface SolarIconDiscProps {
  top?: number;
}

const SolarIconDisc = ({ top = 0 }: SolarIconDiscProps) => (
  <div className="position-relative">
    <IconWrapper top={top}>
      <IconDisc>
        <img alt="Solar icon" src={SolarIcon} />
      </IconDisc>
    </IconWrapper>
  </div>
);

export default SolarIconDisc;
